module.exports = "<pioneer-invoice-history>\n</pioneer-invoice-history>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history-user/invoice-history-user.component.html
// module id = LhFe
// module chunks = 0